@for (chat of sortedChats(); track chat) {
  <div class="chat-row px-n3 align-items-center" [class.hide]="chat.hide" (click)="select(chat);">
    <!-- <div class="avatar-container">
    <sc-avatar [user]="chat?.Users[0]"></sc-avatar>
  </div> -->
  <div class="content-container">
    <div class="content-header">
      <div class="content-header-title">
        <h4 class="mb-0 oneline">{{ chat.Title }}</h4>
      </div>
      <div class="content-header-date">
        <sc-chatbot-chat-date [date]="chat.Changed"></sc-chatbot-chat-date>
      </div>
    </div>
    <div class="content-body align-items-center">
      <div class="content-body-text">
        <p class="text-muted mb-0">
          {{ htmlToPlainText(chat.LastMessage?.Payload?.Body) }}
        </p>
      </div>
      @if (chat?.UnreadMessageCount) {
        <div class="content-body-badge">
          <span class="badge">
            {{ chat.UnreadMessageCount }}
          </span>
        </div>
      }
    </div>
  </div>
</div>
}